module.exports = __webpack_public_path__ + "img/wave-card.7e00b6d2.png";